var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 36.5,
    height: 36.5,
    rx: 9.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4225 25.646C13.0083 25.646 12.6725 25.9818 12.6725 26.396C12.6725 26.8102 13.0083 27.146 13.4225 27.146V25.646ZM9.46967 14.4697C9.17678 14.7626 9.17678 15.2374 9.46967 15.5303L14.2426 20.3033C14.5355 20.5962 15.0104 20.5962 15.3033 20.3033C15.5962 20.0104 15.5962 19.5355 15.3033 19.2426L11.0607 15L15.3033 10.7574C15.5962 10.4645 15.5962 9.98959 15.3033 9.6967C15.0104 9.40381 14.5355 9.40381 14.2426 9.6967L9.46967 14.4697ZM13.4225 27.146H22.5245V25.646H13.4225V27.146ZM22.5245 27.146C26.0837 27.146 28.9725 24.2572 28.9725 20.698H27.4725C27.4725 23.4288 25.2552 25.646 22.5245 25.646V27.146ZM28.9725 20.698C28.9725 17.1388 26.0837 14.25 22.5245 14.25V15.75C25.2553 15.75 27.4725 17.9672 27.4725 20.698H28.9725ZM22.5245 14.25H10V15.75H22.5245V14.25Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/ICON_BACK.ee94e71fb5ed5e08e99b2bfa8bc3dbb2.svg";
export { ForwardRef as ReactComponent };